export const MAX_INPUT_VALUE_LENGTH = 200000
export const MAX_MESSAGE_LENGTH = 140
export const MAX_PUSH_MESSAGE_LENGTH = 1000
export const MAX_SUBJECT_LENGTH = 50
export const EMPTY_HTML_CONTENT = '<p class="editor-paragraph"><br></p>'

export const TEXT_TAG_ACTIVATION_CHAR = '$'
export const textTagSuggestions = [
  'AmountPointsToExpire',
  'CutOffTime',
  'DaysSinceLastLogin',
  'StoreCountry',
  'StoreLastLogonDate',
  'StoreName',
  'StoreOwnerEmailAddress',
  'StoreOwnerFirstName',
  'StoreOwnerLastName',
  'StoreOwnerName',
  'Today',
]
